export default class OPLHomeBannerCarousel {
    constructor() {
        this.panels = document.querySelectorAll('.panel');
        this.carouselTimeout = null;
        this.activeCarouselPanel = 0;
    }

    init() {
        if (this.panels && this.panels.length > 0) {
            this.handlePanelEvents();
            this.startCarousel();
        }
    }

    handlePanelEvents() {
        this.panels.forEach((panel) => {

            // Stop and activate on hover
            panel.addEventListener('mouseover', () => {
                this.stopCarousel();
                this.removeActiveClasses();
                panel.classList.add('active');
            });

            // Resume on mouse leave
            panel.addEventListener('mouseleave', () => {
                this.startCarousel();
            });

            // Stop and activate on focus
            panel.addEventListener('focus', () => {
                this.stopCarousel();
                this.removeActiveClasses();
                panel.classList.add('active');
            });

            // Resume on blur (keyboard navigation)
            panel.addEventListener('blur', () => {
                this.startCarousel();
            });
        });
    }

    startCarousel() {
        this.stopCarousel();
        this.carouselTimeout = setTimeout(() => this.changeCarousel(), 4000);
    }

    stopCarousel() {
        clearTimeout(this.carouselTimeout);
    }

    changeCarousel() {
        this.removeActiveClasses();
        this.panels[this.activeCarouselPanel].classList.add('active');

        this.activeCarouselPanel++;
        if (this.activeCarouselPanel >= this.panels.length) {
            this.activeCarouselPanel = 0;
        }

        this.startCarousel();
    }

    removeActiveClasses() {
        this.panels.forEach((panel) => {
            panel.classList.remove('active');
        });
    }
}
